import React, { Fragment, useCallback, useEffect, useState } from 'react';
import Header from '../../../components/Header';
import Load from '../../../components/Load';
import { Alert, Snackbar } from '@mui/material';
import ConfigTaxaConvenienciaForm from '../../../components/admin/taxaconveniencia/ConfigTaxaConvenienciaForm';
import {
  ConfigTaxaConveniencia,
  ConfigTaxaConvenienciaInput,
  obter,
  salvar,
} from '../../../services/configTaxaConvenienciaService';

const AdminTaxaConveniencia: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState<string | null>(null);
  const [config, setConfig] = useState<ConfigTaxaConveniencia | null>(null);
  const [snackbar, setSnackbar] = useState<{ open: boolean; message: string; severity: 'success' | 'error' }>({
    open: false,
    message: '',
    severity: 'success',
  });

  const showError = (message: string) => setSnackbar({ open: true, message, severity: 'error' });
  const showSuccess = (message: string) => setSnackbar({ open: true, message, severity: 'success' });
  const handleCloseSnackbar = () => setSnackbar((s) => ({ ...s, open: false }));

  const load = useCallback(async () => {
    setLoading(true);
    setLoadError(null);
    try {
      const result = await obter();
      setConfig(result);
    } catch (e: any) {
      setLoadError(e?.message || 'Erro ao carregar a taxa de conveniência.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const handleSave = async (input: ConfigTaxaConvenienciaInput) => {
    try {
      const saved = await salvar(input);
      setConfig(saved);
      showSuccess('Taxa de conveniência salva com sucesso.');
      return saved;
    } catch (e: any) {
      showError(e?.message || 'Erro ao salvar a taxa de conveniência.');
      throw e;
    }
  };

  return (
    <Fragment>
      <div className="main-wrapper">
        <Header />
        <div className="main-content theme-dark-bg right-chat-active">
          <div className="middle-sidebar-bottom">
            <div className="middle-sidebar-left">
              <div className="middle-wrap">
                <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
                  <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3 align-items-center">
                    <button
                      type="button"
                      className="btn btn-link text-white p-0 d-inline-block mt-2 me-4"
                      onClick={() => window.history.back()}
                    >
                      <i className="ti-arrow-left font-sm"></i>
                    </button>
                    <h4 className="font-xs text-white fw-600 mb-0 mt-2 flex-grow-1">
                      Taxa de conveniência
                    </h4>
                  </div>
                </div>

                {loading && <Load />}

                {!loading && loadError && <Alert severity="error">{loadError}</Alert>}

                {!loading && !loadError && (
                  <ConfigTaxaConvenienciaForm initialData={config} onSubmit={handleSave} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Fragment>
  );
};

export default AdminTaxaConveniencia;
